/* eslint-disable max-len */

// 连播状态
export const CONTIMUE_TYPE = {
  YES: 0,
  NO: 1,
};

// 单个课程学习状态
export const STUDY_STATUS = {
  NOT_STARTED: 0,
  STUDYING: 1,
  FINISHED: 2,
  REVIEW: 3,
  PASS: 4,
  NOPASS: 5,
  WXBIND: 6,
  TIMEOUT: 7, // 超时完成
  REVIEW_UN_CALCULATE: 31,
};

// 特训营开课状态
export const CAMP_STATUS = {
  NOT_STARTED: 1,
  PROCESSING: 2,
  OVER: 3,
};

// 页面名称 用于friday上报
export const PAGE_FOR_FRIDAY = {
  CAMP: '训练营',
  NORMAL: '普通课组',
};

// 秒杀后的销售状态
export const SALE_STATE_AFTER_SECKILL = {
  LOWER_SHELF: 1, // 下架
  ORINAL_PRICE: 2, // 原价购买
};

export const SKECKILL_STATE = {
  SOLDOUT_ALLPAY: 0, // 卖完 & 全部付款
  SOLDOUT_PARTIAL_PAY: 1, // 卖完 & 部分未付款
  NOT_SOLD_OUT: 2, // 没卖完
};

/**
 * 课组订单状态
 */
export const GROUP_ORDER_STATE = {
  NO_ODER: -1, // 未下单（前端自定义）
  PAYING: 0, // 支付中
  PLACE_ODER: 1, // 下单但未支付
  PAY_SUC: 2, // 支付成功
  CLOSE: 3, // 订单被关闭
  PAY_ERROR: 4, // 支付错误
  REFUND: 5, // 已申请退款
};

// 考试状态
// 这三个是特训营的状态（新版本后台将这3个状态合并到后面4个）
// 【0：未开始】 --- 已废弃
// 【4: 已通过】 --- 已废弃
// 【5：未通过】 --- 已废弃
// 这四个是普通课组的考试状态
// 【6：用户未开始考试，在考试的测评时间内，即 考试开始时间<当前时间<考试结束时间 重构课组页进入测试按键激活】
// 【7：用户未开始考试，不在考试的测评时间内，即 当前时间<考试开始时间 或 当前时间>考试结束时间 重构课组页进入测试按键置灰 】
// 【8：用户已参加考试，可以重新考试且在测评时间内 重构课组页显示重新考试按钮】
// 【9：用户已参加考试，可以重考但不在考试的测评时间内 或 不可以重考 重构课组页显示查看详情】
export const EXAM_STATE = {
  NOSTART: 0,
  PASS: 4,
  NOPASS: 5,

  JOIN: 6,
  GRAYBOTTON: 7,
  RESTAET: 8,
  DTEAIL: 9,
};

// 课件作业状态 31：审核中（未计算） 3:审核中 4：已通过 5：未通过
export const COURSEWARE_STATE = {
  REVIEW_UN_CALCULATE: 31,
  REVIEW: 3,
  PASS: 4,
  NO_PASS: 5,
};

// 集备练习状态 0：未完成   2：已完成
export const PRELESSONS_STATE = {
  NOSTART: 0,
  FINISHED: 2,
};

// 课程状态映射
export const COURSE_STATE_MAP = {
  0: '未开始',
  1: '学习中',
  2: '已完成',
  3: '审核中',
  4: '已通过',
  5: '未通过',
  6: '已完成',
  7: '超时完成',
  31: '审核中',
};

// 课程格式
export const RESOURCE_TYPE = {
  VIDEO: 0, // 视频
  AUDIO: 1, // 音频
  IMG_TEXT: 2, // 图文
  EXAM: 3, // 考试
  PUNCH_CLOCK: 4, // 打卡
  COURSEWARE: 5, // 课件作业
  WX: 6, // 微信绑定任务
  PRELESSONS: 7, // 集备任务
};

// 课程格式映射
export const RESOURCE_NUM_TEXT_MAP = {
  0: '视频',
  1: '音频',
  2: '图文',
  3: '考试',
  4: '打卡',
  5: '课件作业',
  6: '微信绑定任务',
};

// 课组的整体学习状态
export const GROUP_STUDY_STATUS = {
  NOT_STARTED: 0,
  STUDYING: 1,
  FINISHED: 2,
};

// 是或否（后台回传0或1，消除魔法字符）
export const IS = {
  YES: 1,
  NO: 0,
};

/**
 * 证书状态：六种状态(普通训练营证书解锁状态)
 * 0.进度100：进行中，进度=100%（根据hasCoursewareResource判断是否解锁：有课件不解锁，无课件解锁）
 * 1.锁定：进行中，进度<100%（过期时间从endDate获取）
 * 11.锁定：进行中，进度<100%（过期时间从endDate获取）
 * 12.锁定：进行中，进度<100%，且课件作业审核中
 * 21.解锁：训练营已截止，课件作业审核中（训练营截止时间<当前时间<课件作业审核结束时间）
 * 22.解锁：训练营已截止，课件作业审核中（训练营截止时间<课件作业审核结束时间<当前时间）
 * 3.锁定：训练营已截止，未完成（根据hasCoursewareResource判断是否有课件作业）
 * 4.解锁：训练营已截止，已完成还没认证姓名获取证书
 * 5.解锁：已生成证书
 * 证书状态：三种状态(提升计划训练营证书解锁状态)
 * 5.解锁：已生成证书
 * 6.锁定：提升计划训练营状态  学习进度不到100%
 * 7.解锁：提升计划训练营状态  学习进度已到100%
 */
export const CERTIFICATE_STATUS = {
  FULL_PERCENT: 0,
  PENDING: 1,
  PENDING_NO_REVIEW: 11,
  PENDING_REVIEW: 12,
  TO_REVIEW: 21,
  TO_REVIEW_BUT_LATE: 22,
  UNFINISHED: 3,
  TO_VERIFY: 4,
  DONE: 5,
  PLAN_UNFINISH: 6,
  PLAN_FINISH: 7,
  GENERATING: 8,
  NOT_INIT: 999, // 未初始化，正在请求数据
};

export const CAMP_UNIT_LOCK_WARN = '尚未到单元解锁时间，请届时再来学习哦。';

export const CATA_LOCKED_TYPE = {
  // 有锁、无锁目录
  NONE: 0, // 不上锁
  TIME: 1, // 按时间上锁
};

/**
 * 我的积分 积分账单
 */
export const INTEGRAL_BILL = {
  EXPEND: 1,
  INCOME: 0,
};

/**
 * 课程类型
 */
export const COURSE_TYPE = {
  FULL_AUTION: 'FULL_AUTION', // 全试听课
  LIMIT_AUTION: 'LIMIT_AUTION', // 有限定时间的试听课
  NO_AUTION: 'NO_AUTION', // 非试听课
};

/**
 * 看课完成的判定时间段范围
 * @type {number}
 */
export const LAST_PERIOD_FLAG = 15;

/**
 * Friday 上报间隔时间（单位：秒）
 * @type {number}
 */
export const FRIDAY_REPORT_INTERVAL = 30;

/**
 * 后台上报间隔时间（单位：秒）
 * @type {number}
 */
export const BACKEND_REPORT_INTERVAL = 10;

/**
 * 打卡按钮类型
 */
export const PUNCH_BTN_TYPE = {
  NOT_START: 1,
  PENDING: 2,
  DONE: 3,
  JUMP_NOTE: 4,
};

/**
 * 打卡任务页
 */
export const PUNCH_TASK_BTN = {
  PENDING: 1, // 待打卡
  DONE: 2, // 已打卡
  NOT_BEGIN: 3, // 未开始
  DONE_NO_SHARE: 4, // 已打卡但是不能分享,
  TIME_OUT: 5, //
};

export const CALENDAR_TYPE = {
  PATCH: 0, // 补打卡
  PENDING: 1, // 待打卡
  DONE: 2, // 已打卡
  NOT_BEGIN: 3, // 未开始
};

/* 课组分类页标签字典
 * @type {{原创分享: {学科: *[], 学段: *[], 课型: *[]}, 产品教程: {工具: *[]}, 名师专栏: {主题: *[]}, 案例精选: {学科: *[], 学段: *[]}}}
 */
export const LABEL_DICTIONARY = {
  产品教程: {
    工具: [
      {
        name: '希沃白板5',
        id: 'a0ca04ece82b4ba19d485bc41de44684',
      },
      {
        name: '班级优化大师',
        id: 'bddd89f8fe234c6596baadcb94b43913',
      },
      {
        name: '交互一体机',
        id: '4783f71da836456baf7f971faff079e8',
      },
      {
        name: '易课堂',
        id: 'b4867361fb6d413eafc32054a54bbfc7',
      },
      {
        name: '希沃授课助手',
        id: '37a97dd7b1ff4f00847b661c21eec46c',
      },
      {
        name: '剪辑师',
        id: 'd4653e0aa1134a02a4215a4b15ec0688',
      },
      {
        name: 'office系列',
        id: '9edee65bab514b4a868d331bf8f749ad',
      },
      {
        name: '其他',
        id: '4ef42f5bbc0344e58a522fbcf0f25543',
      },
    ],
  },
  名师专栏: {
    主题: [
      {
        name: '赛课合辑',
        id: 'e8ee9147c48a4d2a9522347434fb1f3d',
      },
      {
        name: '教学方法',
        id: '62c95d8f16cc4cd0be2887d0ea86fe7d',
      },
      {
        name: '课件制作',
        id: '89abe3e65bb845d1823bd56f23acb66a',
      },
      {
        name: '微课制作',
        id: '8123a97f3a784c3e9ca50255d675f98d',
      },
      {
        name: '其他',
        id: 'dd65f522c36a404ab661615238d352d9',
      },
    ],
  },
  案例精选: {
    学段: [
      {
        name: '幼儿园',
        id: 'CodeSchoolStage_4',
      },
      {
        name: '小学',
        id: 'CodeSchoolStage_0',
      },
      {
        name: '初中',
        id: 'CodeSchoolStage_1',
      },
      {
        name: '高中',
        id: 'CodeSchoolStage_2',
      },
      {
        name: '其他',
        id: 'CodeSchoolStage_3',
      },
    ],
    学科: [
      {
        name: '语文',
        id: 'CodeCourseSubject_0',
      },
      {
        name: '数学',
        id: 'CodeCourseSubject_1',
      },
      {
        name: '英语',
        id: 'CodeCourseSubject_2',
      },
      {
        name: '物化生',
        id: 'CodeCourseSubject_3,CodeCourseSubject_4,CodeCourseSubject_5',
      },
      {
        name: '政史地',
        id: 'CodeCourseSubject_8,CodeCourseSubject_6,CodeCourseSubject_7',
      },
      {
        name: '信息技术',
        id: 'CodeCourseSubject_16',
      },
      {
        name: '科体音美',
        id: 'CodeCourseSubject_9,CodeCourseSubject_15,CodeCourseSubject_13,CodeCourseSubject_11',
      },
      {
        name: '其他',
        id:
          'CodeCourseSubject_99,CodeCourseSubject_19,CodeCourseSubject_27,CodeCourseSubject_23,' +
          'CodeCourseSubject_25,CodeCourseSubject_26,CodeCourseSubject_20,CodeCourseSubject_24,CodeCourseSubject_21,CodeCourseSubject_22',
      },
    ],
  },
  原创分享: {
    课型: [
      {
        name: '说课',
        id: '555e2059cbcc4f9bbf627ab59dc8bfa0',
      },
      {
        name: '课堂实录',
        id: '68423a0c8738495dbe210ca64a1081a0',
      },
      {
        name: '巧课例',
        id: 'b1e510bcb7f84bd789bbb9dd0573e88b',
      },
    ],
    学段: [
      {
        name: '幼儿园',
        id: 'CodeSchoolStage_4',
      },
      {
        name: '小学',
        id: 'CodeSchoolStage_0',
      },
      {
        name: '初中',
        id: 'CodeSchoolStage_1',
      },
      {
        name: '高中',
        id: 'CodeSchoolStage_2',
      },
      {
        name: '其他',
        id: 'CodeSchoolStage_3',
      },
    ],
    学科: [
      {
        name: '语文',
        id: 'CodeCourseSubject_0',
      },
      {
        name: '数学',
        id: 'CodeCourseSubject_1',
      },
      {
        name: '英语',
        id: 'CodeCourseSubject_2',
      },
      {
        name: '物化生',
        id: 'CodeCourseSubject_3,CodeCourseSubject_4,CodeCourseSubject_5',
      },
      {
        name: '政史地',
        id: 'CodeCourseSubject_8,CodeCourseSubject_6,CodeCourseSubject_7',
      },
      {
        name: '信息技术',
        id: 'CodeCourseSubject_16',
      },
      {
        name: '科体音美',
        id: 'CodeCourseSubject_9,CodeCourseSubject_15,CodeCourseSubject_13,CodeCourseSubject_11',
      },
      {
        name: '其他',
        id:
          'CodeCourseSubject_99,CodeCourseSubject_19,CodeCourseSubject_27,CodeCourseSubject_23,' +
          'CodeCourseSubject_25,CodeCourseSubject_26,CodeCourseSubject_20,CodeCourseSubject_24,CodeCourseSubject_21,CodeCourseSubject_22',
      },
    ],
  },
};

/**
 * 学段 -> 学科关系表
 * @type {{CodeSchoolStage_4: *[], all: *[], CodeSchoolStage_2: *[], CodeSchoolStage_3: *[], CodeSchoolStage_0: *[], CodeSchoolStage_1: *[]}}
 */
export const STAGE_SUBJECT_CHART = {
  // 幼儿园
  CodeSchoolStage_4: [
    {
      name: '语文',
      id: 'CodeCourseSubject_0',
    },
    {
      name: '数学',
      id: 'CodeCourseSubject_1',
    },
    {
      name: '英语',
      id: 'CodeCourseSubject_2',
    },
    {
      name: '科体音美',
      id: 'CodeCourseSubject_9,CodeCourseSubject_15,CodeCourseSubject_13,CodeCourseSubject_11',
    },
    {
      name: '其他',
      id:
        'CodeCourseSubject_99,CodeCourseSubject_19,CodeCourseSubject_27,CodeCourseSubject_23,' +
        'CodeCourseSubject_25,CodeCourseSubject_26,CodeCourseSubject_20,CodeCourseSubject_24,CodeCourseSubject_21,CodeCourseSubject_22',
    },
  ],
  // 小学
  CodeSchoolStage_0: [
    {
      name: '语文',
      id: 'CodeCourseSubject_0',
    },
    {
      name: '数学',
      id: 'CodeCourseSubject_1',
    },
    {
      name: '英语',
      id: 'CodeCourseSubject_2',
    },
    {
      name: '信息技术',
      id: 'CodeCourseSubject_16',
    },
    {
      name: '科体音美',
      id: 'CodeCourseSubject_9,CodeCourseSubject_15,CodeCourseSubject_13,CodeCourseSubject_11',
    },
    {
      name: '其他',
      id:
        'CodeCourseSubject_99,CodeCourseSubject_19,CodeCourseSubject_27,CodeCourseSubject_23,' +
        'CodeCourseSubject_25,CodeCourseSubject_26,CodeCourseSubject_20,CodeCourseSubject_24,CodeCourseSubject_21,CodeCourseSubject_22',
    },
  ],
  // 初中
  CodeSchoolStage_1: [
    {
      name: '语文',
      id: 'CodeCourseSubject_0',
    },
    {
      name: '数学',
      id: 'CodeCourseSubject_1',
    },
    {
      name: '英语',
      id: 'CodeCourseSubject_2',
    },
    {
      name: '物化生',
      id: 'CodeCourseSubject_3,CodeCourseSubject_4,CodeCourseSubject_5',
    },
    {
      name: '政史地',
      id: 'CodeCourseSubject_8,CodeCourseSubject_6,CodeCourseSubject_7',
    },
    {
      name: '信息技术',
      id: 'CodeCourseSubject_16',
    },
    {
      name: '科体音美',
      id: 'CodeCourseSubject_9,CodeCourseSubject_15,CodeCourseSubject_13,CodeCourseSubject_11',
    },
    {
      name: '其他',
      id:
        'CodeCourseSubject_99,CodeCourseSubject_19,CodeCourseSubject_27,CodeCourseSubject_23,' +
        'CodeCourseSubject_25,CodeCourseSubject_26,CodeCourseSubject_20,CodeCourseSubject_24,CodeCourseSubject_21,CodeCourseSubject_22',
    },
  ],
  // 高中
  CodeSchoolStage_2: [
    {
      name: '语文',
      id: 'CodeCourseSubject_0',
    },
    {
      name: '数学',
      id: 'CodeCourseSubject_1',
    },
    {
      name: '英语',
      id: 'CodeCourseSubject_2',
    },
    {
      name: '物化生',
      id: 'CodeCourseSubject_3,CodeCourseSubject_4,CodeCourseSubject_5',
    },
    {
      name: '政史地',
      id: 'CodeCourseSubject_8,CodeCourseSubject_6,CodeCourseSubject_7',
    },
    {
      name: '信息技术',
      id: 'CodeCourseSubject_16',
    },
    {
      name: '科体音美',
      id: 'CodeCourseSubject_9,CodeCourseSubject_15,CodeCourseSubject_13,CodeCourseSubject_11',
    },
    {
      name: '其他',
      id:
        'CodeCourseSubject_99,CodeCourseSubject_19,CodeCourseSubject_27,CodeCourseSubject_23,' +
        'CodeCourseSubject_25,CodeCourseSubject_26,CodeCourseSubject_20,CodeCourseSubject_24,CodeCourseSubject_21,CodeCourseSubject_22',
    },
  ],
  // 其他
  CodeSchoolStage_3: [
    {
      name: '语文',
      id: 'CodeCourseSubject_0',
    },
    {
      name: '数学',
      id: 'CodeCourseSubject_1',
    },
    {
      name: '英语',
      id: 'CodeCourseSubject_2',
    },
    {
      name: '科体音美',
      id: 'CodeCourseSubject_9,CodeCourseSubject_15,CodeCourseSubject_13,CodeCourseSubject_11',
    },
    {
      name: '其他',
      id:
        'CodeCourseSubject_99,CodeCourseSubject_19,CodeCourseSubject_27,CodeCourseSubject_23,' +
        'CodeCourseSubject_25,CodeCourseSubject_26,CodeCourseSubject_20,CodeCourseSubject_24,CodeCourseSubject_21,CodeCourseSubject_22',
    },
  ],
  // 全部
  all: [
    {
      name: '语文',
      id: 'CodeCourseSubject_0',
    },
    {
      name: '数学',
      id: 'CodeCourseSubject_1',
    },
    {
      name: '英语',
      id: 'CodeCourseSubject_2',
    },
    {
      name: '物化生',
      id: 'CodeCourseSubject_3,CodeCourseSubject_4,CodeCourseSubject_5',
    },
    {
      name: '政史地',
      id: 'CodeCourseSubject_8,CodeCourseSubject_6,CodeCourseSubject_7',
    },
    {
      name: '信息技术',
      id: 'CodeCourseSubject_16',
    },
    {
      name: '科体音美',
      id: 'CodeCourseSubject_9,CodeCourseSubject_15,CodeCourseSubject_13,CodeCourseSubject_11',
    },
    {
      name: '其他',
      id:
        'CodeCourseSubject_99,CodeCourseSubject_19,CodeCourseSubject_27,CodeCourseSubject_23,' +
        'CodeCourseSubject_25,CodeCourseSubject_26,CodeCourseSubject_20,CodeCourseSubject_24,CodeCourseSubject_21,CodeCourseSubject_22',
    },
  ],
};

/**
 * 学科 -> 学段关系表
 * @type {{}}
 */
export const SUBJECT_STAGE_CHART = {
  // 语文
  CodeCourseSubject_0: [
    {
      name: '幼儿园',
      id: 'CodeSchoolStage_4',
    },
    {
      name: '小学',
      id: 'CodeSchoolStage_0',
    },
    {
      name: '初中',
      id: 'CodeSchoolStage_1',
    },
    {
      name: '高中',
      id: 'CodeSchoolStage_2',
    },
    {
      name: '其他',
      id: 'CodeSchoolStage_3',
    },
  ],
  // 数学
  CodeCourseSubject_1: [
    {
      name: '幼儿园',
      id: 'CodeSchoolStage_4',
    },
    {
      name: '小学',
      id: 'CodeSchoolStage_0',
    },
    {
      name: '初中',
      id: 'CodeSchoolStage_1',
    },
    {
      name: '高中',
      id: 'CodeSchoolStage_2',
    },
    {
      name: '其他',
      id: 'CodeSchoolStage_3',
    },
  ],
  // 英语
  CodeCourseSubject_2: [
    {
      name: '幼儿园',
      id: 'CodeSchoolStage_4',
    },
    {
      name: '小学',
      id: 'CodeSchoolStage_0',
    },
    {
      name: '初中',
      id: 'CodeSchoolStage_1',
    },
    {
      name: '高中',
      id: 'CodeSchoolStage_2',
    },
    {
      name: '其他',
      id: 'CodeSchoolStage_3',
    },
  ],
  // 物化生
  'CodeCourseSubject_3,CodeCourseSubject_4,CodeCourseSubject_5': [
    {
      name: '初中',
      id: 'CodeSchoolStage_1',
    },
    {
      name: '高中',
      id: 'CodeSchoolStage_2',
    },
  ],
  // 政史地
  'CodeCourseSubject_8,CodeCourseSubject_6,CodeCourseSubject_7': [
    {
      name: '初中',
      id: 'CodeSchoolStage_1',
    },
    {
      name: '高中',
      id: 'CodeSchoolStage_2',
    },
  ],
  // 信息技术
  CodeCourseSubject_16: [
    {
      name: '小学',
      id: 'CodeSchoolStage_0',
    },
    {
      name: '初中',
      id: 'CodeSchoolStage_1',
    },
    {
      name: '高中',
      id: 'CodeSchoolStage_2',
    },
  ],
  // 科体音美
  'CodeCourseSubject_9,CodeCourseSubject_15,CodeCourseSubject_13,CodeCourseSubject_11': [
    {
      name: '幼儿园',
      id: 'CodeSchoolStage_4',
    },
    {
      name: '小学',
      id: 'CodeSchoolStage_0',
    },
    {
      name: '初中',
      id: 'CodeSchoolStage_1',
    },
    {
      name: '高中',
      id: 'CodeSchoolStage_2',
    },
    {
      name: '其他',
      id: 'CodeSchoolStage_3',
    },
  ],
  // 其他
  'CodeCourseSubject_99,CodeCourseSubject_19,CodeCourseSubject_27,CodeCourseSubject_23,CodeCourseSubject_25,CodeCourseSubject_26,CodeCourseSubject_20,CodeCourseSubject_24,CodeCourseSubject_21,CodeCourseSubject_22': [
    {
      name: '幼儿园',
      id: 'CodeSchoolStage_4',
    },
    {
      name: '小学',
      id: 'CodeSchoolStage_0',
    },
    {
      name: '初中',
      id: 'CodeSchoolStage_1',
    },
    {
      name: '高中',
      id: 'CodeSchoolStage_2',
    },
    {
      name: '其他',
      id: 'CodeSchoolStage_3',
    },
  ],
  // 全部
  all: [
    {
      name: '幼儿园',
      id: 'CodeSchoolStage_4',
    },
    {
      name: '小学',
      id: 'CodeSchoolStage_0',
    },
    {
      name: '初中',
      id: 'CodeSchoolStage_1',
    },
    {
      name: '高中',
      id: 'CodeSchoolStage_2',
    },
    {
      name: '其他',
      id: 'CodeSchoolStage_3',
    },
  ],
};

export const COURSE_GROUP_CLASSIFICATION = {
  产品教程: 'd5d0d3a714d0494fb187bfa57b548cd7',
  名师专栏: '25669795f84b4c148f2cc34afd33533e',
  案例精选: '9e8808b5ae604a3da2f443c496973f47',
  原创分享: '7d18b1722e0542acb8d17a8e0eba373e',
};

export const SUBJECT_MAP = {
  CodeCourseSubject_0: '语文',
  CodeCourseSubject_1: '数学',
  CodeCourseSubject_2: '英语',
  'CodeCourseSubject_3,CodeCourseSubject_4,CodeCourseSubject_5': '物化生',
  'CodeCourseSubject_8,CodeCourseSubject_6,CodeCourseSubject_7': '政史地',
  CodeCourseSubject_16: '信息技术',
  'CodeCourseSubject_9,CodeCourseSubject_15,CodeCourseSubject_13,CodeCourseSubject_11': '科体音美',
  'CodeCourseSubject_99,CodeCourseSubject_19,CodeCourseSubject_27,CodeCourseSubject_23,CodeCourseSubject_25,CodeCourseSubject_26,CodeCourseSubject_20,CodeCourseSubject_24,CodeCourseSubject_21,CodeCourseSubject_22':
    '其他',
};

export const STAGE_MAP = {
  CodeSchoolStage_4: '幼儿园',
  CodeSchoolStage_0: '小学',
  CodeSchoolStage_1: '初中',
  CodeSchoolStage_2: '高中',
  CodeSchoolStage_3: '其他',
};

export const ORDER_TYPE = {
  smart: 'smart',
  time: 'time',
  popularity: 'popularity',
};

export const DEFAULT_ORDER_TYPE = ORDER_TYPE.smart;
export const DEFAULT_HEAD_PHO = 'https://store-g1.seewo.com/avatar/10.png';
export const DEFAULT_IS_ASCENDING = false;

export const ZONE_SORT_TYPE = {
  TIME: 1,
  POPULARITY: 2,
};

// 第一次浏览判断所用的模块id（PC端）
export const VIEW_FIEST_ID = {
  CHECK_WEAK: 'checkweak',
};

export const ZONE_COURSE_TAB = {
  VIDEO_TAB_ID: 'VIDEO_TAB_ID',
  LIVE_TAB_ID: 'LIVE_TAB_ID',
  CUSTOM_TAB_ID: 'CUSTOM_TAB_ID',
};

export const ZONE_LIST_TYPE = {
  VIDEO: 'VIDEO', // 点播视频
  LIVE: 'LIVE', // 直播视频
  BOARD_VIDEO: 'BOARD_VIDEO', // 板块视频
};

export const ZONE_ADD_LIVE_BTN = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
};

export const ZONE_ADD_LIVE_OPERA = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
};

// 专区管理直播页空白页类型
export const ZONE_ADMIN_LIVE_EMPTY_TYPE = {
  ALL_LIVE_EMPTY: 'ALL_LIVE_EMPTY', // 全部空
  ZONE_LIVE_EMPTY: 'ZONE_LIVE_EMPTY', // 专区空
  NO_EMPTY: 'NO_EMPTY', // 非空
};

export const ZONE_ADMIN_ADD_LIVE_EMPTY_TYPE = {
  EMPTY: 'EMPTY',
  NO_EMPTY: 'NO_EMPTY',
};

export const SET_ALL_USER_ROLE = {
  TEACHER: 1,
  STUDENT: 0,
};

// 废弃
export const IS_FIRST_DO_IT = {
  VIDEO_TUTORIAL: 0,
  HOME_GUIDE_SHOW: 1,
};

// 是否已有操作记录
export const HAD_OPTION_RECORD = {
  VIDEO_TUTORIAL: 0,
  HOME_GUIDE_SHOW: 1,
  ABTEST_USER: 2,
};

export const GROUP_PAY_TYPE = {
  FREE: 0,
  WHITE_LIST: 1,
  CHARG: 2,
};

export const CATALOG_STATUS_CLASS = [
  'no-start',
  'normal',
  'pass',
  'review',
  'pass',
  'no-pass',
  'weChat-pass',
  'timeout',
];

export const EN5_URL = 'https://easinote.seewo.com';

export const EN_STATUS = {
  NOT_LOGIN: 0, // 未登录
  NOT_START: 1, // 还未开启售卖（秒杀还未开始）
  NOT_BUY: 2, // 用户没有购买
  NO_AUTH: 3, // 无权限（秒杀已经结束/秒杀已经售罄/白名单）
  NORAML: 4, // 可正常下载
};

export const GUIDE_STEP = {
  HOME_STEP_1: 'home_step_1',
  HOME_STEP_2: 'home_step_2',
  HOME_STEP_3: 'home_step_3',
  HOME_STEP_4: 'home_step_4',
  HOME_STEP_5: 'home_step_5',
};

export const USER_EVENT = {
  PC_INTEGRATION_CENTER: 'pcIntegrationCenter',
};

export const PRODUCT_TYPE = {
  PRODUCT_PYSICAL: 1, // 实物
  PRODUCT_VIRTUAL: 2, // 虚拟商品
  PRODUCT_COUPONS: 3, // 优惠券
};

export const PRODUCT_TYPE_TEXT = {
  1: '实物商品',
  2: '虚拟商品',
  3: '优惠卡商品',
};

export const EXCHANGE_ORDER_STATE = {
  SUCCESS: 1, // 成功
  TODELIVER: 2, // 待发货
  AUDIT: 3, // 审核中
  FAILED: 4, // 审核不通过
  RETURN: 5, // 已退货
};

// 合同状态
export const CONTRACTS_STATUS = {
  NOSIGN: 1, // 待签署
  SIGNING: 2, // 签署中
  DONE: 3, // 已完成
  ABANDON: 4, // 已废弃
};

// 合同状态文本
export const CONTRACTS_STATUS_TEXT = {
  1: '待签署',
  2: '进行中',
  3: '已生效',
  4: '已失效',
};

Object.freeze(STUDY_STATUS);
Object.freeze(PUNCH_BTN_TYPE);
Object.freeze(INTEGRAL_BILL);

export const reviewState = {
  0: 'reviewing',
  1: 'reviewSuccess',
  2: 'reviewFail',
  4: 'reviewing',
  5: 'reviewSuccess',
  6: 'reviewFail',
};

export const BlackHouseModule = {
  topic: 1,
  course: 2,
  punch: 3,
};
